import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

function StudentFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  emailVerifiedFilter,
  onEmailVerifiedFilterChange,
  sort,
  onSortChange,
}) {
  const inputClass =
    "w-full rounded-lg border border-slate-200 py-2.5 px-3 text-[13px] outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100";

  return (
    <div className="mt-3.5 grid grid-cols-1 gap-3 rounded-xl border border-slate-200 bg-white p-4 sm:grid-cols-2 lg:grid-cols-4">
      <div className="relative">
        <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-3.5 text-slate-400" />
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search name or email"
          className={`${inputClass} pl-9`}
        />
      </div>
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        className={inputClass}
      >
        <option value="">All statuses</option>
        <option value="ACTIVE">Active</option>
        <option value="SUSPENDED">Suspended</option>
      </select>
      <select
        value={emailVerifiedFilter}
        onChange={(e) => onEmailVerifiedFilterChange(e.target.value)}
        className={inputClass}
      >
        <option value="">Email: All</option>
        <option value="verified">Verified</option>
        <option value="unverified">Unverified</option>
      </select>
      <select value={sort} onChange={(e) => onSortChange(e.target.value)} className={inputClass}>
        <option value="email">Sort by Email</option>
        <option value="fullName">Sort by Name</option>
        <option value="createdAt">Sort by Date</option>
      </select>
    </div>
  );
}

export default StudentFilters;